// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__Ih5jw","pageSize":"DataTableRemotePaging_pageSize__PYUN+","selected":"DataTableRemotePaging_selected__efJJv"};